/**
 * The longest artist name (`AccountModel.name`) that Music24 takes. The column holds 255
 * characters; a public page title, a share card and a kit image need a much shorter name.
 * The web inputs set it as `maxLength`, and the account PATCH answers 400 above it.
 * This file has no imports, so every project may read it.
 */
export const ARTIST_NAME_MAX_LENGTH = 100;

/** The longest SmartLink page name (`SmartLinkVersionModel.name`, VarChar(255)). */
export const SMART_LINK_NAME_MAX_LENGTH = 255;

/**
 * Cuts a page name to `SMART_LINK_NAME_MAX_LENGTH` characters. It counts code points, so it never
 * cuts an emoji or another surrogate pair in half, and it trims the end. Pure.
 */
export function clampSmartLinkName(name: string): string {
  const codePoints = Array.from(name);
  if (codePoints.length <= SMART_LINK_NAME_MAX_LENGTH) {
    return name;
  }
  return codePoints.slice(0, SMART_LINK_NAME_MAX_LENGTH).join('').trimEnd();
}
